module.exports = __webpack_public_path__ + "media/images/next-31f15875.png";